module.exports = __webpack_public_path__ + "img/removeLight.7667bf03.svg";